import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNpday80 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_80: Record<
  Exclude<PageIdWoofzNpday80, PageIdWoofzNpday80.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NPDAY_80]: {
    id: PageId.SUBSCRIPTIONS_NPDAY_80,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_NPDAY_80]: {
    id: PageId.CHAT_UPSELL_NPDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NPDAY_80]: {
    id: PageId.UPSELL_NPDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NPDAY_80]: {
    id: PageId.DOWNLOAD_NPDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
